export default __webpack_public_path__ + "static/media/SolutionExample.f2d13da4.png";